import { lazy } from "react"

// The signing screen draws with pdf.js, so it loads only when someone signs.
export const LazySignDocument = lazy(() => import("./SignDocument.tsx"))

export type { SignDocumentProps } from "./SignDocument.tsx"
export type {
  AdoptInput,
  FinishResult,
  MarkKind,
  MarkMethod,
  Outcome,
  SigningField,
  SigningState,
  SigningTransport
} from "./types.ts"
